// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3nVE-","row":"ProcedureTreatmentSummary_row___G20G"};